import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/70">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flower-line text-lg"></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50">小宝探花</span>
            </div>
            <p className="text-sm leading-relaxed">
              探花达人带你玩转精彩内容。汇聚最新视频、独家内容与达人动态，打造全新娱乐体验。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm hover:text-background-50 transition-colors">首页</Link>
              <Link to="/category/latest" className="text-sm hover:text-background-50 transition-colors">最新视频</Link>
              <Link to="/category/collection" className="text-sm hover:text-background-50 transition-colors">精彩合集</Link>
              <Link to="/category/welfare" className="text-sm hover:text-background-50 transition-colors">福利活动</Link>
              <Link to="/about" className="text-sm hover:text-background-50 transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">内容分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/latest" className="text-sm hover:text-background-50 transition-colors">最新视频</Link>
              <Link to="/category/dynamic" className="text-sm hover:text-background-50 transition-colors">达人动态</Link>
              <Link to="/category/exclusive" className="text-sm hover:text-background-50 transition-colors">独家内容</Link>
              <Link to="/category/hot" className="text-sm hover:text-background-50 transition-colors">热门推荐</Link>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">关注我们</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs">
            &copy; 2026 小宝探花 版权所有 | 保留一切权利
          </p>
          <div className="flex items-center gap-4 text-xs">
            <a href="#" className="hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors">用户协议</a>
            <a href="#" className="hover:text-background-50 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}